var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-input",
    {
      attrs: { size: "mini", placeholder: "请输入", value: _vm.value },
      on: { input: _vm.input }
    },
    [
      !_vm.backend
        ? _c("el-button", {
            style: { color: "#fff", fontSize: "18px" },
            attrs: {
              slot: "append",
              icon: "el-icon-edit-outline",
              title: "编辑"
            },
            on: { click: _vm.click },
            slot: "append"
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }